// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn[data-v-2b55d987] {
    padding: 0rem 0.5rem;
}
.fa[data-v-2b55d987] {
    margin-right: 0.25rem;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
